import { css } from "@linaria/core";

export const page = css`
  min-height: 100vh;
  background: var(--ant-color-bg-layout);
`;
export const header = css`
  background: var(--ant-color-bg-container);
  box-shadow: var(--ant-box-shadow);
  padding: 0 var(--ant-padding);
  position: sticky;
  top: 0;
  z-index: 10;
`;
export const headerInner = css`
  max-width: 1120px;
  margin: 0 auto;
  height: 64px;
`;
export const logoLink = css`
  gap: var(--ant-margin-xs);
  text-decoration: none;
  color: inherit;
`;
export const logoIcon = css`
  width: 36px;
  height: 36px;
  border-radius: var(--ant-border-radius-sm);
`;
export const logoText = css`
  font-size: var(--ant-font-size-lg);
  text-transform: uppercase;
`;
export const headerLeft = css`
  align-self: stretch;
  gap: var(--ant-margin-lg);
`;
export const nav = css`
  display: flex;
  align-self: stretch;

  @media (max-width: 576px) {
    display: none;
  }
`;
export const navLink = css`
  display: flex;
  align-items: center;
  color: var(--ant-color-text);
  text-decoration: none;
  font-size: var(--ant-font-size);
  padding: 0 var(--ant-padding-sm);
  transition:
    color 0.2s,
    background 0.2s;

  &:hover {
    color: #fff;
    background: var(--ant-color-primary);
  }
`;
export const drawerLink = css`
  display: flex;
  align-items: center;
  color: var(--ant-color-text);
  text-decoration: none;
  font-size: var(--ant-font-size);
  height: var(--ant-control-height);
  padding: 0 var(--ant-padding-sm);
  border-radius: var(--ant-border-radius-sm);
  transition:
    color 0.2s,
    background 0.2s;

  &:hover {
    color: #fff;
    background: var(--ant-color-primary);
  }
`;
export const desktopActions = css`
  gap: var(--ant-margin-sm);

  @media (max-width: 576px) {
    display: none;
  }
`;
export const mobileMenuBtn = css`
  display: none;
  font-size: var(--ant-font-size-xl);

  @media (max-width: 576px) {
    display: inline-flex;
  }
`;
export const mobileDrawer = css`
  display: none;

  @media (max-width: 576px) {
    display: block;
  }
`;
export const drawerClose = css`
  order: 1;
  margin-inline-start: auto;
  margin-inline-end: 0;
`;
export const hero = css`
  position: relative;
  padding: 120px var(--ant-padding-lg) 100px;
  text-align: center;
  overflow: hidden;

  @media (max-width: 576px) {
    padding: 64px var(--ant-padding);
  }
`;
export const heroImage = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const heroOverlay = css`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
`;
export const heroInner = css`
  position: relative;
  max-width: 720px;
  margin: 0 auto;
`;
export const heroTitle = css`
  margin-bottom: var(--ant-margin-sm);
  color: #fff;
`;
export const heroSubtitle = css`
  font-size: var(--ant-font-size-lg);
  max-width: 560px;
  margin: 0 auto var(--ant-margin-lg);
  color: rgba(255, 255, 255, 0.85);
`;
export const heroCta = css`
  gap: var(--ant-margin-sm);
`;
export const heroSignIn = css`
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.5);
  color: #fff;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: #fff;
    color: #fff;
  }
`;

export const featuresStyle = css`
  padding: 64px var(--ant-padding-lg);
  max-width: 1120px;
  margin: 0 auto;
  scroll-margin-top: 64px;
`;
export const featuresTitle = css`
  text-align: center;
  margin-bottom: 48px;
`;
export const featureCard = css`
  text-align: center;
  height: 100%;
  box-shadow: var(--ant-box-shadow);

  & img {
    object-fit: cover;
    aspect-ratio: 16 / 9;
  }
`;
export const pricing = css`
  padding: 64px var(--ant-padding-lg);
  background: var(--ant-color-bg-container);
  scroll-margin-top: 64px;
`;
export const pricingInner = css`
  max-width: 1120px;
  margin: 0 auto;
`;
export const pricingTitle = css`
  text-align: center;
  margin-bottom: var(--ant-margin-sm);
`;
export const pricingSubtitle = css`
  text-align: center;
  font-size: var(--ant-font-size-lg);
  margin-bottom: 48px;
`;
export const pricingCard = css`
  text-align: center;
  height: 100%;
  box-shadow: var(--ant-box-shadow);
`;
export const pricingCardHighlighted = css`
  text-align: center;
  height: 100%;
  border-color: var(--ant-color-primary);
  box-shadow: var(--ant-box-shadow);
`;
export const planPrice = css`
  font-size: var(--ant-font-size-heading-2);
  font-weight: var(--ant-font-weight-strong);
  color: var(--ant-color-primary);
  margin: var(--ant-margin-sm) 0;
`;
export const planFeatures = css`
  text-align: left;
  list-style: none;
  padding: 0;
  margin: var(--ant-margin) 0;
`;

export const planFeature = css`
  padding: var(--ant-padding-xxs) 0;
`;
export const featureCheck = css`
  color: var(--ant-color-success);
  margin-right: var(--ant-margin-xs);
`;

export const footer = css`
  padding: var(--ant-padding-lg);
  text-align: center;
  border-top: var(--ant-line-width) solid var(--ant-color-border-secondary);
  box-shadow: var(--ant-box-shadow);
`;
